import axios, { AxiosResponse } from 'axios';

export const getCharts = (): Promise<AxiosResponse> =>
	axios.get(`/charts/default`);

export const inviteMembers = (type: string): Promise<AxiosResponse> =>
	axios.post(`/charts/default/${type}`);

export const shareByLinkChart = (type: string): Promise<AxiosResponse> =>
	axios.post(`/charts/default/${type}/share`);

export const exportChart = (type: string): Promise<AxiosResponse> =>
	axios.get(`/charts/csv/${type}`);
